import { t } from "@/i18n-js/instance";
import { UserImageWithFallback } from "@/react/components/shared/uikit/UserImageWithFallback";
import { Loader } from "@circle-react-uikit/Loader";
import { useCommunityMembersListContext } from "./CommunityMembersListContext";
import type { Contact } from "./types";

export interface CommunityMemberColumnProps {
  id: number;
  isAvatarHidden?: boolean;
  isLastNameHidden?: boolean;
}

export const CommunityMemberColumn = ({
  id,
  isAvatarHidden,
  isLastNameHidden,
}: CommunityMemberColumnProps) => {
  const communityMembersQuery = useCommunityMembersListContext();

  if (!communityMembersQuery || communityMembersQuery.isLoading) {
    return <Loader center className="!p-0" />;
  }

  const communityMember: Contact | undefined =
    communityMembersQuery.data?.records.find(member => member.id === id);

  if (!communityMember) {
    return (
      <span className="break-normal text-sm">{t("deactivated_member")}</span>
    );
  }

  const {
    first_name: firstName,
    name,
    avatar_url: avatarUrl,
  } = communityMember;

  return (
    <>
      {!isAvatarHidden && (
        <span className="pl-3">
          <div className="float-left">
            <UserImageWithFallback
              size="6"
              src={avatarUrl ?? undefined}
              name={name}
            />
          </div>
        </span>
      )}
      <span className="break-normal text-sm">
        {isLastNameHidden ? firstName : name}
      </span>
    </>
  );
};
